<template>
    <div id="CPIProofViewList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> CPI Proof Review List</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <button v-if="canRunCpiEsc == true" class="btn btn-secondary" v-on:click.prevent='runCPIEsacalation("open")' >Run CPI Escalation</button>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content proof-view-list">
                        <data-table-filter-config :moduleName="'CPIProofViewList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                          <p v-if="batchProcess1" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum1}} is processing please wait!</p>
                          <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>

                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'CPIProofViewList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="listCPIProofReviewTable"
                                      mode="remote"
                                      title="CPI Proof Review"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-select-all="onSelectAll"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <div slot="selected-row-actions">
                                          <a id="selectCPIAllLink" v-show="showSelectAllLink" href="javascript:void(0)" @click="selectAllContract()">Select All {{totalRecords}} records</a>
                                          <button v-if="canSendCpiEsc == true" id="sendAcknowledgeEmailBtn" v-on:click.prevent="loadList('mail')" class="btn btn-primary">Send Rate Change Mail</button>
                                          <button v-if="canSendCpiEsc == true" id="downloadpdfBtn" v-on:click.prevent="loadList('pdf')" class="btn btn-primary">Download PDF</button>
                                          <button v-if="canApproveCpiRate == true" id="approvedBtn" v-on:click.prevent="loadList('final')" class="btn btn-primary">Approve</button>
                                          <button v-if="canApproveCpiRate == true" id="rejectBtn" v-on:click.prevent="loadList('reject')" class="btn btn-primary">Reject</button>
                                          <button v-if="canApproveCpiRate == true" id="postponeBtn" v-on:click.prevent="loadList('postpone')" class="btn btn-primary">Postpone</button>
                                      </div>
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="canApproveCpiRate == true">
                                                      <a type="button" href="javascipt:void(0)" data-toggle="modal" v-on:click.prevent="openCPIProofReviewModal(props.row.id)"><i class="fp-text-document"></i></a>
                                                  </template>
                                              </div>
                                              <div v-if="props.column.field == 'unit_no'">
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <!-- Modal For Cpi Proof Review view Button in Action column -->
                        <div class="modal fade" id="showCPIRateModal" role="dialog">
                            <template v-if="modalArr">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title">{{modalArr.contractCode}} ({{modalArr.contractType}})</h4>
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <!-- if asset not added for this contract show asset no set in this contract -->
                                            <template v-if="modalArr.asset">
                                                <template v-for="(assetData, index) in modalArr.asset">
                                                    <h4 v-bind:key="'asset1' + index"><b>{{formatString(assetData.name)}} ({{assetData.unitNo}})</b></h4>
                                                    CPI Base Value: <span v-bind:key="'asset' + index" class="bg-teal" style="color: #ffff; background: #FFA500;">{{modalArr.effective_rate}}</span><br/>
                                                    <span v-bind:key="'asset1' + index" v-if="modalArr.userName != null">Approved by User: {{formatString(modalArr.userName)}}</span>
                                                    <div class="table-responsive-sm" v-bind:key="'asset' + index">
                                                        <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1" >
                                                            <thead>
                                                                <tr class="table-primary">
                                                                    <th scope="rowgroup" rowspan="2">Description</th>
                                                                    <th scope="rowgroup" colspan="3">Section Rate</th>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="rowgroup">OLD</th>
                                                                    <th scope="rowgroup">NEW</th>
                                                                    <th scope="rowgroup">Increase%</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <!-- if asset is set but section rate is not apply for this asset show no section rate for asset -->
                                                                <template v-if="assetData.section">
                                                                    <tr v-for="(sectionData, index1) in assetData.section" v-bind:key="'section' + index1">
                                                                        <td>{{sectionData.name}}</td>
                                                                        <td class="text-right">{{sectionData.section_value}}</td>
                                                                        <td class="text-right">{{sectionData.new_section_value}}</td>
                                                                        <td v-if="sectionData.new_rate_percent != '-'" class="text-right">{{sectionData.new_rate_percent}}%</td>
                                                                        <td v-else class="text-right">{{'-'}}</td>
                                                                    </tr>
                                                                </template>
                                                                <template v-else>
                                                                    <tr>
                                                                        <td class="no-data-found" colspan="4">{{"No Section Rate Added for Contract Asset Details Module!"}}</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <table aria-describedby="table" id="unit_table" class="table table-bordered font-1" v-bind:key="'asset' + index">
                                                    <tbody>
                                                        <tr>
                                                            <td class="no-data-found" colspan="44">{{"No Asset added for the Contract!"}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </template>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <table aria-describedby="table" id="unit_table" class="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td class="no-data-found" colspan="4">{{"No Data Found!"}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </div>
                        <!-- Model For Run Cpi Escalation Button -->
                        <div class="modal fade" id="runCPIEscalationModal" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        Run CPI Escalation
                                        <button type="button" class="close" data-dismiss="modal" v-on:click.prevent='runCPIEsacalation("close")'>&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <form id="runcpiescalation">
                                            <div class="form-row row-cols-md-2">
                                                <div class="col form-group">
                                                    <label class="control-label" for="contract_type_id">Contract Type:</label>
                                                    <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                            label="text"
                                                            :options="contractTypeArr">
                                                    </v-select>
                                                    <div class="field-error cpi-date-error">{{ contract_type_error_msg }}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="effective_date">Effective Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker>
                                                        <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error cpi-date-error">{{ effective_date_error_msg }}</div>
                                                </div>
                                                <!-- <div class="col form-group">
                                                    <label class="control-label" for="anniversary_point">CPI Anniversary Point:</label>
                                                    <v-select v-model="anniversary_point" name="anniversary_point" placeholder="Select Cpi Anniversary Point."
                                                            label="text"
                                                            :options="anniversaryPointArr">
                                                    </v-select>
                                                </div> -->
                                            </div>
                                            <div class="cpi-modal-btm">
                                                <div class="font-bold">Last Run Details</div>
                                                <div style="font-size:14px;">
                                                    <label class="" for="old_effective_date">Effective CPI Date: {{old_effective_cpi_date}}</label><br/>
                                                    <label class="" for="status">Status: {{old_status}}</label>
                                                </div>
                                                <p class="field-error cpi-date-error">Enter a target date after the last: </p>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" id="cancelCPIEsacalation" class="btn btn-tertiary" data-dismiss="modal" v-on:click.prevent='runCPIEsacalation("close")' > <i class="fp-close"> </i> Cancel</button>
                                        <button type="button" id="saveCPIEsacalation" class="btn btn-primary" v-on:click.prevent='runCPIEsacalation("store")' > <i class="fp-save"> </i> Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>

</template>

<script>

import Vue from "vue";


import EventBus from "./event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import CustomPagination from '@/components/layout/CustomPagination';
import {dataTableMixins} from '../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);


Vue.component("custom-pagination", CustomPagination);
let msgServer;
    export default {
        name: "CPIProofViewList",
        mixins:[commonMixins,contractMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                     label: 'Actions',
                     field: 'action',
                     sortable: false,
                },
                {
                    label: 'Unit No',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    html: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    hidden:false,
                },
                {
                    label: 'Contract Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Prior Effective Date',
                    field: 'prior_date',
                    filterable: true,
                    sortable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'New Effective Date',
                    field: 'new_effective_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    sortable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Creation Date',
                    field: 'creation_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    sortable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    // sortable: false,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems: ['Final', 'Preliminary'],
                    }
                },
                // {
                //     label: 'Preliminary Creation Date',
                //     field: 'preliminary_creation_date',
                //     filterable: true,
                //     sortable: false,
                //     filterOptions: {
                //         enabled: true, // enable filter for this column
                //         placeholder: "MM/DD/YYYY", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Final Approval Date',
                    field: 'approved_date',
                    filterable: true,
                    sortable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Approved By',
                    field: 'approved_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Approved By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Code',
                    field: 'customer_code',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                /*
                {
                    label: 'Address Line 1',
                    field: 'address_1',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Address", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Address Line 2',
                    field: 'address_2',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Address", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State',
                    field: 'state',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Country',
                    field: 'country',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Country", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Postal Code',
                    field: 'zip',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Postal Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                */
                {
                    label: 'Phone',
                    field: 'phone_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Fax',
                    field: 'fax',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Fax", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Facility', // Responsible Facility
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Credit Manager', // Responsible Facility
                    field: 'credit_manager',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Credit Manager", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                /*
                {
                    label: 'Customer Class',
                    field: 'custClass',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Customer Class", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                */
            ],
            rows: [],
            showSelectAllLink:false,
            totalRecords: 0,
            allSelected:"",
            selectedPageRows:0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            modalArr: [],
            contract_type_id: null,
            contractTypeArr: [],
            contract_type_error_msg: "",
            effective_date: "",
            effective_date_error_msg: "",
            anniversary_point: null,
            anniversaryPointArr: [],
            cpi_anniversary_point_error: "",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            old_effective_cpi_date: "",
            old_status: "",
            loading: false,
            canRunCpiEsc:false,
            canSendCpiEsc:false,
            canApproveCpiRate:false,
            batchId:0,
            batchNum1:'',
            batchProcess1:false,
            batchProcess:0,
            batchNum:"",
            batchError:false,
            batchErrorMsg:""

        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_cpi_proof_review') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'run_cpi_escalation') {
                            self.canRunCpiEsc = true;
                        }
                        if (permissions[i].name == 'send_cpi_rate_acknowledge') {
                            self.canSendCpiEsc = true;
                        }
                        if (permissions[i].name == 'approve_cpi_rate_change') {
                            self.canApproveCpiRate = true;
                        }
                    }
                }
            },
        },
        created: function() {

        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        mounted: function() {

            var self = this;
            self.getPermissions();
            //self.loadCPIProofReview();
            self.anniversaryPointArr = self.cpiAnniversaryPointArr;
            self.loadFieldData(['contractTypeWithAll']);
            console.log("COME MSG");
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listCPIProofReviewTable.unselectAllInternal();
            },
            checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess1 = false;
                            self.loadList('list');
                            sse.close();
                        }else if (data.status == "2") {
                            self.batchProcess1 = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },

            // updateParams(newProps) {
            //     this.serverParams = Object.assign({}, this.serverParams, newProps);
            // },

            // onPageChange(params) {
            //     this.updateParams({page: params.currentPage});
            //     this.loadCPIProofReview('list');
            // },

            // onPerPageChange(params) {
            //     this.serverParams.page=1;
            //     this.updateParams({perPage: params.currentPerPage});
            //     this.totalRecords = self.totalRecords;
            //     this.loadCPIProofReview('list');
            // },

            // onColumnFilter(params) {
            //     this.updateParams(params);
            //     {
            //         field:('name');
            //         field:('code');
            //         field:('description');
            //     };
            //     var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            //     var filters = filtersPr.columnFilters;
            //     if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
            //         this.loadCPIProofReview('list');
            //     }
            // },

            // onSortChange(params) {
            //     this.updateParams({
            //         sort: {
            //             type: params[0].type,
            //             field: params[0].field,
            //         },
            //     });
            //     this.loadCPIProofReview('list');
            // },

            //click on select all link
            selectAllContract:function() {

                this.allSelected = "all";
                var selectAllText = "All "+ this.totalRecords +" rows are selected";

                //override selected record of page
                $("#selectCPIAllLink").text(selectAllText);
                $("#selectCPIAllLink").closest(".vgt-pull-right").css({"width": "100%", "position": "absolute","left":"0","top":"0","background":"#ffff"});
                $(".custom-class").css("margin-bottom","10px");

            },

            onSelectAll(params) {

                if ( params.selectedRows.length > 0 ) {
                    this.showSelectAllLink = true;
                } else {
                    this.showSelectAllLink = false;
                }
            },

            selectionChanged(params) {
                var self = this;

                self.selectedPageRows = params.selectedRows.length;
                //remove select all link if checkbox count change
                if ( self.totalRecords != params.selectedRows.length ) {
                    self.showSelectAllLink = false;
                    self.allSelected = "";
                }
                self.serverParams.selectedAll = false;
                if(params.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;

            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listCPIProofReviewTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            //load cpi proof review data
            loadList(flag) {

                var self = this;
                var confirmation_value = false;
                if (flag == '' || flag == undefined){
                    flag = 'list';
                }
                if(self.action == 'export' || self.action == 'export_queue'){
                  flag = self.action;
                }
                var records = [];
                if ( flag != "list" ) {
                    var data = self.$refs['listCPIProofReviewTable'].selectedRows;

                    for (var i = 0; i < data.length; i++) {
                        records.push(this.$refs['listCPIProofReviewTable'].selectedRows[i].contract_id)
                    }
                }

                if (  flag == "pdf" ) {
                    $("#downloadpdfBtn").text("Downloading ...");
                    $("#downloadpdfBtn").prop("disabled", true);
                } else if (flag == "mail" ) {
                    $("#sendAcknowledgeEmailBtn").text("Sending ...");
                    $("#sendAcknowledgeEmailBtn").prop("disabled", true);
                } else if (flag == "final") {
                    $("#approvedBtn").text("Approving ...");
                    $("#approvedBtn").prop("disabled", true);
                }else if (flag == "reject") {
                    $("#rejectBtn").text("Rejecting ...");
                    $("#rejectBtn").prop("disabled", true);
                }else if (flag == "postpone") {
                    $("#postponeBtn").text("Postpone ...");
                    $("#postponeBtn").prop("disabled", true);
                } else if (flag == "preliminary") {
                    $("#disapprovedBtn").text("Disapproving ...");
                    $("#disapprovedBtn").prop("disabled", true);
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag:flag,
                    checkAll:self.serverParams.selectedAll,
                    // checkAll:'all',
                    ids:records
                };
                self.firstLoad = 1;

                // Confirmation for final or preliminary contract.
                if (flag == "final" ) {

                    var data = self.$refs['listCPIProofReviewTable'].selectedRows;

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].status == 'reject' || data[i].status == 'postpone'){

                        }
                        // records.push(this.$refs['listCPIProofReviewTable'].selectedRows[i].id)
                    }

                    if (confirm('Are you sure to Approved this Contract? ')) {
                        confirmation_value = false;
                    } else {
                        confirmation_value = true;
                        self.loading = false;
                        $("#approvedBtn").text("Approved");
                        $("#approvedBtn").prop("disabled", false);
                    }

                }if (flag == "reject" ) {

                    var data = self.$refs['listCPIProofReviewTable'].selectedRows;

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].status == 'Final'){
                            self.$swal('','Record already approved','info');
                            $("#rejectBtn").text("Reject");
                            $("#rejectBtn").prop("disabled", false);
                            self.loading = false;
                            return;
                        }
                        // records.push(this.$refs['listCPIProofReviewTable'].selectedRows[i].id)
                    }
                    if (confirm('Are you sure to Reject this Contract? ')) {
                        confirmation_value = false;
                    } else {
                        confirmation_value = true;
                        self.loading = false;
                        $("#rejectBtn").text("Reject");
                        $("#rejectBtn").prop("disabled", false);
                    }

                }if (flag == "postpone" ) {

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].status == 'Final'){
                            self.$swal('','Record already approved','info');
                            $("#postponeBtn").text("Postpone");
                            $("#postponeBtn").prop("disabled", false);
                            self.loading = false;
                            return;
                        }
                        // records.push(this.$refs['listCPIProofReviewTable'].selectedRows[i].id)
                    }
                    if (confirm('Are you sure to Postpone this Contract? ')) {
                        confirmation_value = false;
                    } else {
                        confirmation_value = true;
                        self.loading = false;
                        $("#postponeBtn").text("Postpone");
                        $("#postponeBtn").prop("disabled", false);
                    }

                } else if ( flag == "preliminary" ){

                    if (confirm('Are you sure to Disapproved this Contract? ')) {
                        confirmation_value = false;
                    } else {
                        confirmation_value = true;
                        self.loading = false;
                        $("#disapprovedBtn").text("Disapproved");
                        $("#disapprovedBtn").prop("disabled", false);
                    }

                } else if (flag == "list" || flag == "mail" || flag == "pdf"){
                    confirmation_value = false;
                }

                // ajax call for if confirmation value is false for all flag.
                if (!confirmation_value) {
                    $.ajax({
                        url: process.env.ROOT_API + "/cpiproofreview/list",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (  flag == "pdf" ) {
                                $("#downloadpdfBtn").text("Download PDF");
                                $("#downloadpdfBtn").prop("disabled", false);
                            } else if (flag == "mail" ) {
                                $("#sendAcknowledgeEmailBtn").text("Send Rate Change Mail");
                                $("#sendAcknowledgeEmailBtn").prop("disabled", false);
                            } else if (flag == "final") {
                                $("#approvedBtn").text("Approved");
                                $("#approvedBtn").prop("disabled", false);
                            } else if (flag == "preliminary") {
                                $("#disapprovedBtn").text("Disapproved");
                                $("#disapprovedBtn").prop("disabled", false);
                            }else if (flag == "reject") {
                                $("#rejectBtn").text("Reject");
                                $("#rejectBtn").prop("disabled", false);
                            }else if (flag == "postpone") {
                                $("#postponeBtn").text("Postpone");
                                $("#postponeBtn").prop("disabled", false);
                            }

                            // console.log(data.content.row.length);
                            if (data.status == "success") {
                                setTimeout(function() {
                                    if ( flag == "pdf" ) {

                                        if (data.content != "") {

                                            var link = document.createElement('a');
                                            document.body.appendChild(link);
                                            link.href = data.content;
                                            link.download = '';
                                            link.target = "_blank";
                                            link.click();
                                            // document.body.removeChild(link);
                                        }

                                    } else if ( self.action == "export" ||  self.action == "export_queue") {
                                        if ( data.code == "201" ) {
                                            alert(data.message);
                                        } else {
                                            if ( self.action == "export" ) {
                                                self.excel = data.content.web;
                                                var save = document.createElement("a");
                                                save.href = self.excel;
                                                save.download = data.content.web;
                                                save.target = "_blank";

                                                document.body.appendChild(save);
                                                save.click();
                                                document.body.removeChild(save);

                                            } else {

                                                self.batchProcess = 1;
                                                self.batchNum = data.content;
                                            }
                                        }
                                        self.action = "";
                                        self.loadList('list');

                                    } else if ( flag == "mail" ) {

                                        alert("Mail sent Successfully");

                                    } else if ( flag == "final") {

                                        self.loadList('list');
                                        alert(data.content);

                                    }else if ( flag == "reject") {

                                        self.loadList('list');
                                        alert(data.content);

                                    }else if ( flag == "postpone") {

                                        self.loadList('list');
                                        alert(data.content);

                                    } else if ( flag == "preliminary") {

                                        self.loadList('list');
                                        alert(data.content);

                                    } else {

                                        self.rows = data.content.row;
                                        self.totalRecords = data.content.totalRecords;
                                        self.filteredFlag = false;

                                        if (data.content.row[0] != undefined) {

                                            self.old_effective_cpi_date = data.content.row[0].new_effective_date;
                                            self.old_status = data.content.row[0].status;

                                        }
                                    }
                                },200);


                            } else {
                                setTimeout(function() {
                                    alert(data.message);
                                },200);

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;

                            if (  flag == "pdf" ) {
                                $("#downloadpdfBtn").text("Download PDF");
                                $("#downloadpdfBtn").prop("disabled", false);
                            } else if (flag == "mail" ) {
                                $("#sendAcknowledgeEmailBtn").text("Send Rate Change Mail");
                                $("#sendAcknowledgeEmailBtn").prop("disabled", false);

                            }

                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 403) {
                                    self.cantAccessPage = false;
                                }
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }

                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },

            // open Data modal for cpi proof review cpi rate.
            openCPIProofReviewModal(id){

                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/get-cpiproofreview-modal-data",
                    type: "GET",
                    data: {
                        "id":id
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {

                            if (data.content != "") {

                                if(data.content.zero_value) {
                                    alert("Contract asset rate percentage is 0, Please check it.");

                                } else {
                                    self.modalArr = data.content[0];
                                    $('#showCPIRateModal').modal('show');
                                }

                            } else {
                                self.modalArr = [];
                                $('#showCPIRateModal').modal('show');
                            }

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 403) {
                                self.cantAccessPage = false;
                            }
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            runCPIEsacalation(flag) {

                var self = this;
                var error = false;

                self.contract_type_error_msg = "";
                self.effective_date_error_msg = "";
                self.cpi_anniversary_point_error = "";

                // open data modal for run cpi escalation.
                if (flag == "open") {

                    $('#runCPIEscalationModal').modal('show');

                } else if (flag == "close") {

                    self.contract_type_id = null;
                    self.effective_date = "";
                    self.anniversary_point = null;

                    $('#runCPIEscalationModal').modal('hide');

                } else {

                    // if(self.contract_type_id == null || !self.contract_type_id.value) {

                    //     self.contract_type_error_msg = "Contract Type Required.";
                    //     error = true;
                    // }

                   /*  if(self.anniversary_point == null || !self.anniversary_point.value) {

                        self.cpi_anniversary_point_error = "Anniversary Point Required.";
                        error = true;
                    } */

                    if(self.effective_date == null || self.effective_date == "" || !self.effective_date) {

                        self.effective_date_error_msg = "Effective Date Required.";
                        error = true;
                    }

                    if (!error) {

                        $("#saveCPIEsacalation").text("Saving ...");
                        $("#saveCPIEsacalation").prop("disabled", true);
                        $("#cancelCPIEsacalation").prop("disabled",true);

                        var fields = $("#runcpiescalation").serializeArray();
                        // if (self.contract_type_id.value == "ALL" || self.contract_type_id == null || !self.contract_type_id.value ) {

                        //     if( self.anniversary_point == null || !self.anniversary_point.value ) {
                        //         fields.push({name: "anniversary_point", value: ""});
                        //     } else {
                        //         fields.push({name: "anniversary_point", value: self.anniversary_point.value});
                        //     }

                        //     fields.push({name: "flag", value: "ALL"});

                        // } else {
                            if (self.contract_type_id != null && self.contract_type_id.value){

                                fields.push({name: "contract_type_id", value: self.contract_type_id.value});

                            }
                            // fields.push({name: "anniversary_point", value: self.anniversary_point.value});
                            // if( self.anniversary_point == null || !self.anniversary_point.value ) {
                            //     fields.push({name: "anniversary_point", value: ""});
                            // } else {
                            //     fields.push({name: "anniversary_point", value: self.anniversary_point.value});
                            // }
                            fields.push({name: "flag", value: "single"});
                        // }

                        // ajax call for store cpi proof review table.
                        $.ajax({
                            url: process.env.ROOT_API + "/cpiproofreview/store-data",
                            type: "POST",
                            data: fields,
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;

                                $("#saveCPIEsacalation").text("Save");
                                $("#saveCPIEsacalation").prop("disabled", false);
                                $("#cancelCPIEsacalation").prop("disabled",false);

                                if (data.status == "success") {

                                    // console.log(data.content);
                                    self.anniversary_point = null;
                                    self.contract_type_id = null;
                                    self.effective_date = "";

                                    if(data.batch){
                                        self.batchId = data.batch;
                                        self.batchProcess1 = true;
                                        self.batchNum1 = data.batchNum;
                                        self.checkBatchStatus();
                                    }

                                    $('#runCPIEscalationModal').modal('hide');
                                    self.loadList("list");

                                    // if(data.content.cpi_month == "effectiveCPIRate") {
                                    //     alert(data.message); // message for please add first effective cpi rate for current month.
                                    // } else if(data.content.cpi_month == "asset_not_found") {
                                    //     alert(data.message); // message for contract asset is not match exipry date or frequency date is not match for effecive cpi date.
                                    // } else if(data.content.cpi_month == "success") {
                                    //     if (data.content.queryCount != 0) {
                                    //         alert(data.content.queryCount + " Contract are already exists.");
                                    //     }
                                    // }
                                    // else {
                                    //     alert("Contract can not be detected for this effective date!");
                                    // }

                                } else {

                                    /* if (data.content.length > 0) {
                                        var err = "";

                                        for (var i = 0; i < data.content.length; i++) {

                                            err += data.content[i] + "<br>";
                                        }

                                        $("#errorMsg").html(err);
                                        $(".alert-warning").toggleClass("show");
                                        setTimeout(function () {
                                            $(".alert-warning").removeClass("show");
                                            $(".alert-warning").addClass("hide");
                                        }, 10000);
                                    } */
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;

                                $("#saveCPIEsacalation").text("Save");
                                $("#saveCPIEsacalation").prop("disabled", false);
                                $("#cancelCPIEsacalation").prop("disabled",false);

                                if (jqXHR.status == 0) {
                                    self.errorMsg = "Remote server cannot be reached";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("tkn");

                                        self.$router.push("/");
                                    }
                                    // $("#errorMsg").html(jqXHR.responseJSON.message);
                                    // $(".alert-warning").toggleClass("show");
                                    // setTimeout(function () {
                                    //     $(".alert-warning").removeClass("show");
                                    //     $(".alert-warning").addClass("hide");
                                    // }, 10000);
                                }
                            }
                        });


                    }
                }

            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        }
    };
</script>





// WEBPACK FOOTER //
// src/components/CPIProofReviewList.vue